export enum RppQuestionAnswer {
  NEVER = "never",
  VERY_RARELY = "very_rarely",
  SOMETIMES = "sometimes",
  OFTEN = "often",
  VERY_OFTEN = "very_often",
  NO_ANSWER = "no_answer",
}
